export default function TreezLargeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 666 326.2"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <g transform="translate(-603 -340.044)">
              <g>
                <g transform="translate(623.833 365.579)">
                  <path
                    fill="#6BAA32"
                    d="M536.9 29.6c3.5 0 8.2 1.7 9.5 4.7l25.1 59.4 12.8 31.1 38.2 90.5v21.8c.1 4.6-3.6 8.4-8.2 8.5h-57.1c-4.6-.1-8.3-3.9-8.2-8.5v-22.4h34.7c4.5-.2 8.1-3.9 8-8.5 0-1.1-.2-2.1-.6-3.1l-27.5-69.4-12-31.3-8.3-20c-.9-3.4-6.1-5.3-8.3 0"
                  ></path>
                  <path
                    fill="currentColor"
                    d="M77.8 29.6h17.1c4.6.1 8.3 3.9 8.2 8.5l.1 8.4v14h-26c-4.6.1-8.3 3.9-8.2 8.5v177H44.4c-4.6-.1-8.3-3.9-8.2-8.5V69c.1-4.6-3.6-8.4-8.2-8.5H1.9V48.9l-.1-10.8c-.1-4.6 3.6-8.4 8.2-8.5h67.8z"
                    className="st1"
                  ></path>
                  <path
                    fill="currentColor"
                    d="M183.6 245.9v-66.1c0-20.1-5.6-26.6-20.5-26.6H160c-4.6.1-8.3 3.9-8.2 8.5V246h-24.6c-4.6-.1-8.3-3.9-8.2-8.5V55.1l-.1-13v-4c-.1-4.6 3.6-8.4 8.2-8.5h40.4c33.9 0 48.5 16.4 48.5 49.8v13.3c0 22.3-6.9 36.5-21.4 42.7v.6c16.4 5.3 21.7 21.3 21.7 45.8v55.7c.1 4.6-3.6 8.4-8.2 8.5h-24.5m-31.9-132.2c-.1 4.6 3.6 8.4 8.2 8.5h3.7c12.2 0 19.6-5.6 19.6-22.9V82.7c0-15.5-5.1-22.3-16.7-22.3h-6.7c-4.6.1-8.3 3.9-8.2 8.5l.1 44.9z"
                    className="st1"
                  ></path>
                  <path
                    fill="currentColor"
                    d="M407.3 245.9h-52c-4.6-.1-8.3-3.9-8.2-8.5V38.1c-.1-4.6 3.6-8.4 8.2-8.5h72.9c4.6.1 8.3 3.9 8.2 8.5v22.4h-48.5c-4.3.1-7.9 3.5-8.1 7.8v40.8c-.1 4.6 3.6 8.4 8.2 8.5h36.8v30.9H388c-4.6.1-8.3 3.9-8.2 8.5v49.5c-.1 4.6 3.6 8.4 8.2 8.5h48.4v22.4c.1 4.6-3.6 8.4-8.2 8.5m-20.9.1l29.1-16.9"
                    className="st1"
                  ></path>
                  <path
                    fill="currentColor"
                    d="M545.1 38.1v.2m-41.4 37.9l1.6-4c.4-1 .6-2.1.6-3.2.1-4.6-3.6-8.4-8.2-8.5h-45.6V38.1c-.1-4.6 3.6-8.4 8.2-8.5h76.5c4.6.1 8.3 3.9 8.2 8.5v21.8l-56.2 143.6c-.4 1-.6 2.1-.6 3.1-.1 4.6 3.5 8.3 8 8.5h34.7v22.4c.1 4.6-3.6 8.4-8.2 8.5h-65.5c-4.6-.1-8.3-3.9-8.2-8.5v-21.8l54.7-139.5"
                    className="st1"
                  ></path>
                  <path
                    fill="currentColor"
                    d="M299.2 245.9h-52.1c-4.6-.1-8.3-3.9-8.2-8.5V38.1c-.1-4.6 3.6-8.4 8.2-8.5H320c4.6.1 8.3 3.9 8.2 8.5v22.4h-48.5c-4.3.1-7.9 3.5-8.1 7.8v40.8c-.1 4.6 3.6 8.4 8.2 8.5h36.8v30.9h-36.8c-4.6.1-8.3 3.9-8.2 8.5v49.5c-.1 4.6 3.6 8.4 8.2 8.5h48.4v22.4c.1 4.6-3.6 8.4-8.2 8.5h-20.8m0 .1l29.1-16.9"
                    className="st1"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
